import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import logo from "../assets/logo/Logo-BlueZone.png";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  const toggleMobileDropdown = () => {
    setMobileDropdownOpen(!mobileDropdownOpen);
  };

  const closeAllMenus = () => {
    setExpanded(false);
    setMobileDropdownOpen(false);
  };

  return (
    <Navbar
      expand="lg"
      bg="white"
      className="header shadow-sm"
      expanded={expanded}
    >
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}
            alt="Blue-zone"
            className="logo-content"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link
              as={Link}
              to="/"
              active={location.pathname === "/"}
              onClick={closeAllMenus}
            >
              Trang chủ
            </Nav.Link>

            {/* Desktop Dropdown */}
            <NavDropdown
              title={
                <>
                  Dịch vụ
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ms-1"
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </>
              }
              id="basic-nav-dropdown"
              className={`d-none d-lg-block ${
                location.pathname.includes("/dich-vu") ? "active" : ""
              }`}
            >
              <NavDropdown.Item
                as={Link}
                to="/dich-vu/vay-online"
                active={location.pathname === "/dich-vu/vay-online"}
                onClick={closeAllMenus}
              >
                Vay Online
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/dich-vu/mo-the"
                active={location.pathname === "/dich-vu/mo-the"}
                onClick={closeAllMenus}
              >
                Mở Thẻ
              </NavDropdown.Item>
            </NavDropdown>

            {/* Mobile Dropdown */}
            <div className="d-lg-none mobile-dropdown">
              <div
                className="mobile-dropdown-toggle"
                onClick={toggleMobileDropdown}
              >
                <span>Dịch vụ</span>
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`ms-1 mobile-dropdown-arrow ${
                    mobileDropdownOpen ? "rotated" : ""
                  }`}
                >
                  <path
                    d="M1 1.5L6 6.5L11 1.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div
                className={`mobile-dropdown-content ${
                  mobileDropdownOpen ? "show" : ""
                }`}
              >
                <Nav.Link
                  as={Link}
                  to="/dich-vu/vay-online"
                  active={location.pathname === "/dich-vu/vay-online"}
                  onClick={closeAllMenus}
                  className="mobile-dropdown-item"
                >
                  Vay Online
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/dich-vu/mo-the"
                  active={location.pathname === "/dich-vu/mo-the"}
                  onClick={closeAllMenus}
                  className="mobile-dropdown-item"
                >
                  Mở Thẻ
                </Nav.Link>
              </div>
            </div>

            <Nav.Link
              as={Link}
              to="/tin-tuc"
              active={location.pathname.startsWith("/tin-tuc")}
              onClick={closeAllMenus}
            >
              Tin tức
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/lien-he"
              active={location.pathname.startsWith("/lien-he")}
              onClick={closeAllMenus}
            >
              Liên hệ
            </Nav.Link>

            <Link to={"/dich-vu/vay-online"} className="btn-link">
              <Button className="register-button" onClick={closeAllMenus}>
                Đăng ký vay
              </Button>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
